export default __webpack_public_path__ + "static/media/icon_greekFeet_left.28e76c55.png";